import React, { useState } from 'react';
import { Project } from '../types';
import './ProjectCard.css';

interface ProjectCardProps {
  project: Project;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ project }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className="ProjectCard"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img 
        src={isHovered && project.hoverImageURL ? project.hoverImageURL : project.imageURL} 
        alt={project.title}
      />
      <h3 className="Venue">{project.venue}</h3>
      <h2>{project.title}</h2>
      <p className="Authors">{project.authors?.join(', ')}</p>
      <div className="links-row">
        {project.projectURL && (
          <a href={project.projectURL} target="_blank" 
            rel="noopener noreferrer">Project</a>
        )}&nbsp;
        {project.videoURL && (
          <a href={project.videoURL} target="_blank" 
            rel="noopener noreferrer">Video</a>
        )}&nbsp;
        {project.paperURL && (
          <a href={project.paperURL} target="_blank" 
            rel="noopener noreferrer">Paper</a>
        )}&nbsp;
        {project.codeURL && (
          <a href={project.codeURL} target="_blank" 
            rel="noopener noreferrer">Code</a>
        )}
      </div>
    </div>
  );
};

export default ProjectCard; 